import { ImageAtoms } from '@vfit/shared/atoms';
import { purify } from '@vfit/shared/themes';
import { useDeviceType } from '@vfit/shared/hooks';
import { ICard, IImage, ISmartPassport } from './SmartPassportCard.models';
import {
  MainContainer,
  SmartCardUnit,
  Title,
  UnitIcon,
  UnitIcons,
  UnitLocation,
  UnitQuota,
  UnitTitle,
} from './SmartPassport.style';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCards, FreeMode, Keyboard, Mousewheel, Pagination } from 'swiper';
import { trackLink } from '@vfit/shared/data-access';
import { Children } from 'react';
import { getSlideSize } from './SmartPassport.utils';

const SmartPassportCard = ({ title, subtitle, cards }: ISmartPassport) => {
  const { isDesktop, isTablet, isMobile } = useDeviceType();
  const [pTitle, pSubTitle] = purify([title, subtitle]);

  return (
    <MainContainer>
      {pTitle && <Title dangerouslySetInnerHTML={{ __html: pTitle }} />}
      {pSubTitle && <Title dangerouslySetInnerHTML={{ __html: pSubTitle }} />}
      <Swiper
        slidesPerView="auto"
        effect="slide"
        cardsEffect={{
          // rotate: true,
          slideShadows: false,
        }}
        spaceBetween={32}
        freeMode={false}
        mousewheel={{
          forceToAxis: true,
        }}
        centeredSlides={false}
        keyboard
        pagination={{
          clickable: true,
        }}
        onSlideChange={(swiper) => {
          trackLink(`V1:swipe${swiper.activeIndex < swiper.previousIndex ? '-' : '+'}`);
        }}
        modules={[Pagination, FreeMode, Mousewheel, Keyboard, EffectCards]}
      >
        {Children.toArray(
          cards?.map((smartPassport: ICard, index: number) => {
            let marginLeft = 0;
            if (index === 0) {
              if (isDesktop) marginLeft = 80;
              else if (isTablet) marginLeft = 32;
            }
            if (index === 0 && isMobile) marginLeft = 0;
            const customSize = getSlideSize(isMobile, isTablet);
            return (
              <SwiperSlide
                style={{
                  marginLeft,
                  ...customSize,
                  cursor: 'pointer',
                  overflow: 'initial',
                }}
              >
                <SmartCardUnit>
                  <UnitTitle>{smartPassport?.title}</UnitTitle>
                  <UnitQuota>{smartPassport?.quota}</UnitQuota>
                  <UnitLocation>{smartPassport?.location}</UnitLocation>
                  <UnitIcons>
                    {smartPassport?.icons?.map((icon: IImage) => (
                      <UnitIcon>
                        <ImageAtoms nameCard={icon?.icon || 'img'} image={icon?.icon} />
                      </UnitIcon>
                    ))}
                  </UnitIcons>
                </SmartCardUnit>
              </SwiperSlide>
            );
          })
        )}
      </Swiper>
    </MainContainer>
  );
};

export default SmartPassportCard;

